export interface MobileForSplit {
  id:                string
  driverId:          string | null
  truckId:           string | null
  trailerId:         string | null
  driverName:        string | null
  truckUnitNumber:   number | null
  truckLicensePlate: string | null
}

export interface SplitImpact {
  /** True when user overrode at least one resource vs. the Tramo 2 mobile's defaults. */
  resourcesModified:      boolean
  /** True when the selected driver is currently assigned to Tramo 1's mobile. */
  driverBelongsToTramo1:  boolean
  /** True when the selected trailer is currently assigned to Tramo 1's mobile. */
  trailerBelongsToTramo1: boolean
  /** True when mobileId was auto-updated because the selected truck belongs to a different mobile. */
  mobileSwitchedByTruck:  boolean
  /** Human-readable label for Tramo 1 mobile, e.g. "M21" or license plate or fallback "Tramo 1". */
  tramo1Label:            string
  /** Human-readable label for Tramo 2 mobile, e.g. "M240" or license plate or fallback "Tramo 2". */
  tramo2Label:            string
}

function mobileLabel(mobile: MobileForSplit | null | undefined, fallback: string): string {
  if (!mobile) return fallback
  if (mobile.truckUnitNumber != null) return `M${mobile.truckUnitNumber}`
  return mobile.truckLicensePlate ?? fallback
}

export function analyzeSplitImpact(params: {
  splitDriverId:  string
  splitTruckId:   string
  splitTrailerId: string
  splitMobileId:  string
  tramo1Mobile:   MobileForSplit | null | undefined
  tramo2Mobile:   MobileForSplit | null | undefined
}): SplitImpact {
  const { splitDriverId, splitTruckId, splitTrailerId, splitMobileId, tramo1Mobile, tramo2Mobile } = params

  const resourcesModified = !!(splitMobileId && tramo2Mobile && (
    splitDriverId  !== (tramo2Mobile.driverId  ?? "") ||
    splitTruckId   !== (tramo2Mobile.truckId   ?? "") ||
    splitTrailerId !== (tramo2Mobile.trailerId ?? "")
  ))

  const driverBelongsToTramo1  = !!(splitDriverId  && tramo1Mobile?.driverId  && splitDriverId  === tramo1Mobile.driverId)
  const trailerBelongsToTramo1 = !!(splitTrailerId && tramo1Mobile?.trailerId && splitTrailerId === tramo1Mobile.trailerId)

  // True when the truck was auto-switched to a different mobile (truck belongs to tramo2Mobile, not tramo1Mobile)
  const mobileSwitchedByTruck  = !!(splitTruckId && tramo2Mobile && tramo2Mobile.truckId === splitTruckId && tramo2Mobile.id !== (tramo1Mobile?.id ?? ""))

  return {
    resourcesModified,
    driverBelongsToTramo1,
    trailerBelongsToTramo1,
    mobileSwitchedByTruck,
    tramo1Label: mobileLabel(tramo1Mobile, "Tramo 1"),
    tramo2Label: mobileLabel(tramo2Mobile, "Tramo 2"),
  }
}
